import { BrowserRouter, Routes, Route, Outlet } from "react-router"
import LoginPage from "./pages/auth/LoginPage"
import SignupPage from "./pages/auth/SignupPage"
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage"
import ResetPasswordPage from "./pages/auth/ResetPasswordPage"
import OnboardingPage from "./pages/org-admin/onboarding/OnboardingPage"
import SettingsPage from "./pages/settings/index"
import InvitationAcceptPage from "./pages/invitation/InvitationAcceptPage"
import PostSchedulePage from "./pages/post-schedule/index"
import PostCreatePage from "./pages/post-schedule/new"
import DashboardPage from "./pages/analytics/DashboardPage"
import FeedPostsPage from "./pages/analytics/FeedPostsPage"
import StoriesPage from "./pages/analytics/StoriesPage"
import ReelsPage from "./pages/analytics/ReelsPage"
import FeedPostDetailPage from "./pages/analytics/FeedPostDetailPage"
import StoryDetailPage from "./pages/analytics/StoryDetailPage"
import ReelDetailPage from "./pages/analytics/ReelDetailPage"
import CategoriesPage from "./pages/analytics/CategoriesPage"
import CategoryDetailPage from "./pages/analytics/CategoryDetailPage"
import CompetitorsPage from "./pages/analytics/CompetitorsPage"
import CompetitorDetailPage from "./pages/analytics/CompetitorDetailPage"
import HashtagsPage from "./pages/analytics/HashtagsPage"
import HashtagDetailPage from "./pages/analytics/HashtagDetailPage"
import FanUsersPage from "./pages/analytics/FanUsersPage"
import FanUserDetailPage from "./pages/analytics/FanUserDetailPage"
import AiReportPage from "./pages/analytics/AiReportPage"
import NotificationsPage from "./pages/notifications/NotificationsPage"
import HelpPage from "./pages/help/HelpPage"
import ProtectedRoute from "./components/ProtectedRoute"
import { AccountProvider, useSelectedAccount } from "./contexts/AccountContext"
import { NotificationsProvider } from "./contexts/NotificationsContext"

const EditOnlyRoute = ({ element }: { element: React.ReactElement }) => {
  const { selectedAccountId, currentPermission } = useSelectedAccount()
  if (selectedAccountId !== null && currentPermission === "view") {
    window.location.href = "/no-permission.html"
    return null
  }
  return element
}

// 認証済みページ共通レイアウト: ProtectedRoute + AccountProvider を1回だけマウント
const AuthenticatedLayout = () => (
  <ProtectedRoute>
    <AccountProvider>
      <NotificationsProvider>
        <Outlet />
      </NotificationsProvider>
    </AccountProvider>
  </ProtectedRoute>
)

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* 認証不要 */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/invitations/:token" element={<InvitationAcceptPage />} />

        {/* /onboarding: 組織未所属でもアクセス可能 */}
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute>
              <OnboardingPage />
            </ProtectedRoute>
          }
        />

        {/* 認証必須（AccountProvider 共有） */}
        <Route element={<AuthenticatedLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/feed-posts" element={<FeedPostsPage />} />
          <Route path="/feed-posts/:postId" element={<FeedPostDetailPage />} />
          <Route path="/stories" element={<StoriesPage />} />
          <Route path="/stories/:postId" element={<StoryDetailPage />} />
          <Route path="/reels" element={<ReelsPage />} />
          <Route path="/reels/:postId" element={<ReelDetailPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/categories/:categoryId" element={<CategoryDetailPage />} />
          <Route path="/competitors" element={<CompetitorsPage />} />
          <Route path="/competitors/:competitorId" element={<CompetitorDetailPage />} />
          <Route path="/hashtags" element={<HashtagsPage />} />
          <Route path="/hashtags/*" element={<HashtagDetailPage />} />
          <Route path="/fan-users" element={<FanUsersPage />} />
          <Route path="/fan-users/:owner_id" element={<FanUserDetailPage />} />
          <Route path="/ai-report" element={<AiReportPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/post-schedule" element={<PostSchedulePage />} />
          <Route path="/post-schedule/new" element={<EditOnlyRoute element={<PostCreatePage />} />} />
          <Route path="/post-schedule/:id" element={<EditOnlyRoute element={<PostCreatePage />} />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
